import { Directive, inject, input, TemplateRef } from '@angular/core';

/**
 * `<ng-template shCell="key" let-row let-value="value">` replaces the cell of
 * the column with that key. The context is `{ $implicit: row, value }`.
 */
@Directive({
  selector: 'ng-template[shCell]',
  standalone: true,
})
export class ShCellDirective {
  readonly key = input.required<string>({ alias: 'shCell' });
  readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}

/** `<ng-template shEmpty>` replaces the standard empty state. */
@Directive({
  selector: 'ng-template[shEmpty]',
  standalone: true,
})
export class ShEmptyDirective {}
